/**
 * Asynchronously loads the component for DeliverPrintTickets
 */

import { lazyLoad } from 'utils/loadable';

export const DeliverPrintTickets = lazyLoad(
  () => import('./index'),
  module => module.DeliverPrintTickets,
);
